import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PdfService } from '@app/services/pdf/pdf.service';
import { Router } from '@angular/router';
import { MemberService } from '@app/services/member.service';

@Component({
  selector: 'app-kontoinformation',
  templateUrl: './kontoinformation.component.html',
  styleUrls: ['./kontoinformation.component.css']
})
export class KontoinformationComponent implements OnInit {
  @ViewChild('contentToConvert', { static: true }) content;
  memberdata;
  constructor(
    private pdfservice: PdfService,
    private memberService: MemberService,
    private router: Router) { }

  ngOnInit() {
    this.memberService.newmemberdata.subscribe(sub => {
      if (sub) {
        this.memberdata = sub;
        this.getPrimaryInstitutionForMember(this.memberdata.memberId);
      }
    });
  }

  getPrimaryInstitutionForMember(memberid: number) {
    this.memberService.getMemberPrimaryInstitution(memberid).subscribe(m => {
      if (m) {
        this.memberdata['primaryInstitution'] = m.shortName + ' ' + m.name;
      };
    })
  }
  captureScreen() {
    this.pdfservice.captureScreen(this.content, 'p', null);
    this.router.navigate(['/memberform/id/', this.memberdata.memberId]);
  }

  continue() {
    this.router.navigate(['/memberform/id/', this.memberdata.memberId]);
  }
}
